import { configs } from '@app/configs';
import { loadLang } from '@app/i18next.config';
import TagManager from 'react-gtm-module';
export const initializeGTM = () => {
    TagManager.initialize({
        gtmId: configs.GTM_ID,
        dataLayer: {
            language: loadLang,
        },
    });
};
// Implement custom "optin" event to tell tag manager which cookies can be stored.
export const checkCookieConsent = () => {
    if (configs.HUBSPOT_ID) {
        const _hsq = window._hsq = window._hsq || [];
        _hsq.push(['addPrivacyConsentListener', function (consent) {
                // Note: As simplification we asume all cookies are used for ads ignoring:
                // console.log(`analytics: ${consent.categories.analytics}`)
                // console.log(`functionality: ${consent.categories.functionality}`)
                if (consent.categories.advertisement) {
                    TagManager.initialize({
                        gtmId: configs.GTM_ID,
                        events: {
                            event: 'optin',
                        },
                    });
                }
            }]);
    }
    else {
        TagManager.initialize({
            gtmId: configs.GTM_ID,
            events: {
                event: 'optin',
            },
        });
    }
};
export const reportSignupGTM = ({ email, language }) => {
    TagManager.initialize({
        gtmId: configs.GTM_ID,
        events: {
            event: 'signup',
            language: language || 'en',
            email,
        },
    });
};
